import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './DevelopmentForm.css'

import { NewProjectForm } from "./NewProjectForm";
import { FormSupport } from "./FormSupport";

function DevelopmentForm(){
    return(
        <React.Fragment>

            <div className="container">

                <div className="wrapper">

                    <div className="card-switch">

                        <label className="switch">

                            <input type="checkbox" className="toggle" />

                            <span className="slider"></span>

                            <span className="card-side"></span>

                            <div className="flip-card__inner">

                                {/* Form card front */}
                                <div className="flip-card__front">
                                    <NewProjectForm />             
                                </div>

                                {/* Form card back */}
                                <div className="flip-card__back">
                                    <FormSupport />                
                                </div>

                            </div>

                        </label>

                    </div>   

                </div>
                
            </div>

        </React.Fragment>
    );
}

export { DevelopmentForm };